import { useQuery } from "react-query";
import { api } from "utils/api";
import { submissionKeys } from "./queryKeys";
import type { OpenCallSubmission } from "../types";

const getOpenCallSubmission = (openCallId?: string, submissionId?: string) =>
  api.get<{ openCall?: OpenCallSubmission }>(
    `/open-call/submission/${openCallId}/${submissionId}`
  );

const useOpenCallSubmission = (openCallId?: string, submissionId?: string) =>
  useQuery(
    submissionKeys.detail(openCallId, submissionId),
    () => getOpenCallSubmission(openCallId, submissionId),
    {
      enabled: !!(openCallId && submissionId),
      // This is not great name for the property, it's actually the OpenCallSubmission
      select: (resp) => resp.openCall,
    }
  );

export { useOpenCallSubmission };
